A formatted description of the position profile.
